import { render, staticRenderFns } from "./PopupController.vue?vue&type=template&id=1ec6d331&scoped=true"
import script from "./PopupController.vue?vue&type=script&lang=js"
export * from "./PopupController.vue?vue&type=script&lang=js"
import style0 from "./PopupController.vue?vue&type=style&index=0&id=1ec6d331&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec6d331",
  null
  
)

export default component.exports